// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","info":"styles_info__mSOxh","notificationIcon":"styles_notificationIcon__PBITk","username":"styles_username__v9kjW"};